import { useEffect } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { batch, useSignal } from "@preact/signals-react"

import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"


export default function useHistoryInfo(idReportExecution = null, idOfficePickup = null, idBatch = null) {
    const data = useSignal([])
    const isLoading = useSignal(false)
    const { showToast } = useToast()

    useEffect(() => {
        isLoading.value = true
        getSubmit(`${BACKEND_APIS.HISTORICAL}/manual-searches?idReportExecution=${idReportExecution}&idOfficePickup=${idOfficePickup}&idBatch=${idBatch}`)
            .then(res => batch(() => {
                data.value = res
                isLoading.value = false
            })).catch(() => {
                showToast.error("Error retrieving real time history")
                isLoading.value = false
            })
    }, [])
    return {
        data: data.value,
        isLoading: isLoading.value
    }
}